import { Badge, Card, Group, Stack, Switch, Text } from '@buildex/ui';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { MODULE_IDS } from '@buildex/module-contract';
import { tenantModuleToggled } from '@/entities/tenant/model';
import type { AdminTenant } from '@/entities/tenant/types';
import { MODULE_LABELS } from '@/shared/module-meta';

interface ModuleTogglesProps {
  tenant: AdminTenant;
}

/** Тумблеры модулей тенанта. Фактическая проверка оплаты — на бэке (§9 п.2) */
export function ModuleToggles({ tenant }: ModuleTogglesProps) {
  const { t } = useTranslation();
  const onToggle = useUnit(tenantModuleToggled);

  return (
    <Stack gap="sm" maw={640}>
      <Text size="sm" c="dimmed">
        {t('modules.hint')}
      </Text>
      {MODULE_IDS.map((moduleId) => {
        const enabled = tenant.modules.includes(moduleId);
        return (
          <Card key={moduleId} padding="md">
            <Group justify="space-between" wrap="nowrap">
              <Group gap="sm">
                <Badge variant={enabled ? 'filled' : 'light'} color={enabled ? 'brand' : 'gray'}>
                  {moduleId}
                </Badge>
                <Text size="sm" fw={550}>
                  {MODULE_LABELS[moduleId]}
                </Text>
              </Group>
              <Switch
                checked={enabled}
                onChange={(e) =>
                  onToggle({ tenantId: tenant.id, moduleId, enabled: e.currentTarget.checked })
                }
              />
            </Group>
          </Card>
        );
      })}
    </Stack>
  );
}
